/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Apikeys_DescriptionInputs */

const en_settings_overview_apikeys_description = /** @type {(inputs: Settings_Overview_Apikeys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active keys`)
};

const zh_settings_overview_apikeys_description = /** @type {(inputs: Settings_Overview_Apikeys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活跃密钥`)
};

/**
* | output |
* | --- |
* | "Active keys" |
*
* @param {Settings_Overview_Apikeys_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_apikeys_description = /** @type {((inputs?: Settings_Overview_Apikeys_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Apikeys_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_apikeys_description(inputs)
	return zh_settings_overview_apikeys_description(inputs)
});
export { settings_overview_apikeys_description as "settings.overview.apikeys_description" }